<div class="confirmGeneric">
    <div class="confirmGeneric-wrapper">


        <div class="confirmGeneric-wrapper-header">

            <div class="headerTitleContainer">
                <berry-typo class="headerTitle" [color]="'secondary'" *ngIf="!title">{{'Warning_CorrespondenceNew'| translate}}</berry-typo>
                <berry-typo class="headerTitle" [color]="'secondary'" *ngIf="!!title">{{title| translate}}</berry-typo>
            </div>
            <div>
                <berry-icon [size]="20" [color]="'secondary'" [name]="'close'" (click)="dismiss()"></berry-icon>
            </div>

        </div>

        <div class="confirmGeneric-wrapper-container" *ngIf="!!subTitle">
            <berry-typo class="headerTitle" [name]="'body1'" [color]="'secondary'">{{subTitle | translate}}</berry-typo>
        </div>

        <div class="confirmGeneric-wrapper-footer">
            
            <ng-container *ngIf="!!closeButtonText">
                <berry-button [data-automation-id]="'confirm-dismiss'"
                              [label]="closeButtonText | translate"
                              (click)="dismiss()"
                              size="medium"
                              type='secondary'>
                </berry-button>
            </ng-container>
            <ng-container *ngIf="!!submitButtonText">
                <berry-button [data-automation-id]="'confirm-submit'"
                              [type]="getSubmitButtonColor"
                              [label]="submitButtonText | translate"
                              (click)="submit()"
                              size="medium">
                </berry-button>
            </ng-container>

        </div>

    </div>
</div>
